import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: (p) => p.spacing(2, 1),
  backgroundColor: (p) => p.palette.common.white,
  height: (p) => p.spacing(37),
};

export const emptyIconWrapperSX: SxStyle = {
  p: 0,
};
